import { DatabaseCode, toDatabaseCode } from "./database-code";

export type FileStorageType = DatabaseCode;

const local: FileStorageType = {
  code: "LOCAL",
  displayValue: {
    id: "common.entity.filestoragetype.local",
    defaultMessage: "Local",
  },
};

const s3: FileStorageType = {
  code: "S3",
  displayValue: {
    id: "common.entity.filestoragetype.s3",
    defaultMessage: "S3",
  },
};

export const fileStorageType = {
  local,
  s3,
};

export const fileStorageTypes = Object.values(fileStorageType);

export const toFileStorageType = (code: string): FileStorageType =>
  toDatabaseCode(code, fileStorageTypes);

export const toFileStorageTypeSafely = (
  code: string | undefined
): FileStorageType | undefined =>
  code ? toDatabaseCode(code, fileStorageTypes) : undefined;
